<template>
    <div>
        <div class="d-flex flex-column flex-root" v-if="$store.getters['global/isLoaded']">
            <!-- begin:: Header Mobile -->
            <KTHeaderMobile></KTHeaderMobile>
            <!-- end:: Header Mobile -->

            <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>

            <b-modal id="modal-scrollable"
                     ok-only
                     ok-title="تایید"
                     scrollable
                     @ok="nextPopup"
                     :title="totalPopup[0] ? totalPopup[0].title:'' ">

                <p class="my-4"
                   v-html="totalPopup[0] ? totalPopup[0].description : ''"></p>
            </b-modal>

            <!-- begin::Body -->
            <div class="d-flex flex-row flex-column-fluid page">
                <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
                    <!-- begin:: Header -->
                    <KTHeader></KTHeader>
                    <!-- end:: Header -->

                    <!-- begin:: Content -->
                    <div
                            id="kt_content"
                            class="content d-flex flex-column flex-column-fluid"
                            style="margin-top: 17rem"
                    >
                        <!-- begin:: Content Head -->

                        <!-- begin:: Content Head -->
                        <!--          <KTSubheader-->
                        <!--              v-if="subheaderDisplay"-->
                        <!--              v-bind:breadcrumbs="breadcrumbs"-->
                        <!--              v-bind:title="pageTitle"-->
                        <!--          />-->
                        <!-- end:: Content Head -->

                        <!-- begin:: Content Body -->
                        <div class="d-flex flex-column-fluid">
                            <div :class="{'container-fluid': contentFluid,container: !contentFluid}">
                                <div class="d-lg-flex flex-row-fluid">
                                    <!-- begin:: Aside Left -->
                                    <div class="d-block bg-danger d-md-none">
                                        <KTAside v-if="asideEnabled"></KTAside>
                                    </div>
                                    <!-- end:: Aside Left -->

                                    <div class="content-wrapper flex-row-fluid mx-10">
                                        <transition name="fade-in-up">
                                            <div>
                                                <!--this is our plugin.-->
                                                <terminal_title_ribbon></terminal_title_ribbon>
                                                <router-view/>
                                            </div>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <KTFooter></KTFooter>
                </div>
            </div>
            <!--        <KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar>-->
            <KTScrollTop></KTScrollTop>
            <navigation></navigation>
            <wallet :show-button="false"></wallet>
        </div>

        <modal/>
    </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeader from "@/view/layout/header/Header.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import Loader from "@/view/content/Loader.vue";
import wallet from "@/view/pages/transactions/wallet"
import Wallet from "@/view/pages/transactions/wallet"
import {ADD_BODY_CLASSNAME, REMOVE_BODY_CLASSNAME} from "@/core/services/store/htmlclass.module.js";

import modal from "@/core/plugins/EasyModal/view"
import Navigation from "@/view/layout/aside/Navigation";

export default {
    name: "Layout",
    components: {
        Navigation,
        Wallet,
        KTAside,
        KTHeader,
        KTHeaderMobile,
        KTFooter,
        KTSubheader,
        KTStickyToolbar,
        KTScrollTop,
        Loader,
        wallet,
        modal,
    },
    data() {
        return {
            qrUrl: '',
            pLandUrl: 'http://localhost:8080/',
            text: [],
            totalPopup: [],
        }
    },
    methods: {
        ...mapActions('tutorial', [
            'setTutorials',
        ]),
        getWallet() {
            $.ajax({
                url: `${url}/user/wallet`,
                headers: {
                    Authorization: Token,
                    "ACCEPT": 'application/json',
                },
                fn: this.getWallet,
                type: 'GET',
                success: (data) => {
                    this.$store.dispatch("wallet/setWallet", data.data);
                }
            })
        },
        getProfile() {
            $.ajax({
                url: `${url}/user/profile`,
                headers: {
                    Authorization: Token,
                    "ACCEPT": 'application/json',
                },
                fn: this.getProfile,
                type: 'GET',
                success: (data) => {
                    this.user = data.data
                    this.$store.state.user = data.data.name;
                    this.$store.state.userImage = data.data.image;
                }
            })
        },
        nextPopup(event) {
            const lastItem = this.totalPopup.splice(0, 1);
            let seen = JSON.parse(localStorage.getItem('popup'));

            seen.push(lastItem[0].id);

            localStorage.setItem('popup', JSON.stringify(seen));

            if (this.totalPopup.length > 0)
                event.preventDefault();
        }
    },
    beforeMount() {
        // show page loading
        this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
        // initialize html element classes
        HtmlClass.init(this.layoutConfig());
    },
    mounted() {
        // check if current user is authenticated
        if (!this.isAuthenticated) {
            return this.$router.push({name: "login"});
        }
        let url = window.location.href;
        const start = url.indexOf("?");
        const end = url.indexOf("#");

        url = url.substring(start, end);
        let fullUrl = document.URL;

        window.history.pushState('dashboard', 'Title', fullUrl.substr(end));
        let token = localStorage.getItem('id_token');
        if (url === '?redirect=qr') {
            return window.location.replace(`${this.qrUrl}?token=${token}`);
        }
        if (url === '?redirect=Pland') {
            return window.location.replace(`${this.pLandUrl}?token=${token}`);
        }

        // Simulate the delay page loading
        setTimeout(() => {
            // Remove page loader after some time
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
        }, 2000);


    },
    computed: {
        ...mapGetters([
            "isAuthenticated",
            "breadcrumbs",
            "pageTitle",
            "layoutConfig"
        ]),
        ...mapGetters('tutorial', [
            'popups',
            'popupSlugs',
        ]),
        /**
         * Check if the page loader is enabled
         * @returns {boolean}
         */
        loaderEnabled() {
            return !this.layoutConfig("loader.type");
        },
        /**
         * Check if container width is fluid
         * @returns {boolean}
         */
        contentFluid() {
            return this.layoutConfig("content.width") === "fluid";
        },

        /**
         * Page loader logo image using require() function
         * @returns {string}
         */
        loaderLogo() {
            return this.layoutConfig("loader.logo");
        },

        /**
         * Check if the left aside menu is enabled
         * @returns {boolean}
         */
        asideEnabled() {
            return !!this.layoutConfig("aside.self.display");
        },

        /**
         * Set the right toolbar display
         * @returns {boolean}
         */
        toolbarDisplay() {
            // return !!this.layoutConfig("toolbar.display");
            return true;
        },

        /**
         * Set the subheader display
         * @returns {boolean}
         */
        subheaderDisplay() {
            return !!this.layoutConfig("subheader.display");
        }
    },
    watch:{
        $route(to, from) {
            let popupExists = this.popupSlugs.indexOf(to.path.substring(1)) > -1

            if (popupExists) {
                let seen = JSON.parse(localStorage.getItem('popup'))
                let popup = this.popups

                this.totalPopup = popup[to.path.substring(1)].filter(item => seen.indexOf(item.id) < 0);

                if (this.totalPopup.length > 0)
                    this.$bvModal.show('modal-scrollable');
            }

            let footer = window.document.querySelector("#kt_footer")
            if (to.path == '/home') {
                footer.classList.add("manamanam")
            } else {
                footer.classList.remove("manamanam")
            }
        },
    }
};
</script>
<style>
.v-navigation-drawer {
    background-image: linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)), url('/media/bg/bg-menu.jpg');
    background-size: 256px 100%;

    background-repeat: no-repeat;
}
</style>